import { render } from "./AdminTrainings.vue?vue&type=template&id=1722c2a7"
import script from "./AdminTrainings.vue?vue&type=script&lang=js"
export * from "./AdminTrainings.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__